import { App } from '@/App.tsx'
import { AxiosAPI } from '@/external/api/api.ts'
import { SocketIO } from '@/external/socket.ts'
import { createStore } from '@/store'
import '@repo/tailwind-config/global.css'
import '@repo/ui/lang'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from 'react-redux'
import { PostHogConfig } from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import './styles.css'

const api = new AxiosAPI(import.meta.env.VITE_API_URL).api()

const store = createStore({
  api,
  socket: SocketIO.getInstance(),
})
export type AppDispatch = typeof store.dispatch

const postHogOptions: Partial<PostHogConfig> = {
  api_host: import.meta.env.VITE_PUBLIC_POSTHOG_HOST,
  defaults: '2025-05-24',
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <PostHogProvider apiKey={import.meta.env.VITE_PUBLIC_POSTHOG_KEY} options={postHogOptions}>
      <Provider store={store}>
        <App />
      </Provider>
    </PostHogProvider>
  </StrictMode>,
)
